export default "__VITE_ASSET__CS2jKzB6__"